var docReady = function docReady(fn) {
	// see if DOM is already available
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', fn);
	} else {
		setTimeout(fn, 1);
	}
};
var hasClass = function hasClass(el, className) {
	return el ? el.classList.value.includes(className) : false;
};
var getItemFromStore = function getItemFromStore(key, defaultValue) {
	var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : localStorage;

	try {
	return JSON.parse(store.getItem(key)) || defaultValue;
	} catch (_unused) {
	return store.getItem(key) || defaultValue;
	}
};
var setItemToStore = function setItemToStore(key, payload) {
	var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : localStorage;
	return store.setItem(key, payload);
};
var utils = {
	hasClass: hasClass,
	getItemFromStore: getItemFromStore,
	setItemToStore: setItemToStore
};
var handleNavbarVerticalCollapsed = function handleNavbarVerticalCollapsed() {
	var Selector = {
	HTML: 'html',
	NAVBAR_VERTICAL_TOGGLE: '.navbar-vertical-toggle',
	NAVBAR_VERTICAL_COLLAPSE: '.navbar-vertical .navbar-collapse',
	ECHART_RESPONSIVE: '[data-echart-responsive]'
	};
	var Events = {
	CLICK: 'click',
	MOUSE_OVER: 'mouseover',
	MOUSE_LEAVE: 'mouseleave',
	NAVBAR_VERTICAL_TOGGLE: 'navbar.vertical.toggle'
	};
	var ClassNames = {
	NAVBAR_VERTICAL_COLLAPSED: 'navbar-vertical-collapsed',
	NAVBAR_VERTICAL_COLLAPSED_HOVER: 'navbar-vertical-collapsed-hover'
	};
	var navbarVerticalToggle = document.querySelector(Selector.NAVBAR_VERTICAL_TOGGLE);
	var html = document.querySelector(Selector.HTML);
	var navbarVerticalCollapse = document.querySelector(Selector.NAVBAR_VERTICAL_COLLAPSE);

	if (navbarVerticalToggle) {
	navbarVerticalToggle.addEventListener(Events.CLICK, function (e) {
		navbarVerticalToggle.blur();
		html.classList.toggle(ClassNames.NAVBAR_VERTICAL_COLLAPSED); // Set collapse state on localStorage

		var isNavbarVerticalCollapsed = utils.getItemFromStore('isNavbarVerticalCollapsed');
		utils.setItemToStore('isNavbarVerticalCollapsed', !isNavbarVerticalCollapsed);
		var event = new CustomEvent(Events.NAVBAR_VERTICAL_TOGGLE);
		e.currentTarget.dispatchEvent(event);
	});
	}

	if (navbarVerticalCollapse) {
	navbarVerticalCollapse.addEventListener(Events.MOUSE_OVER, function () {
		if (utils.hasClass(html, ClassNames.NAVBAR_VERTICAL_COLLAPSED)) {
		html.classList.add(ClassNames.NAVBAR_VERTICAL_COLLAPSED_HOVER);
		}
	});
	navbarVerticalCollapse.addEventListener(Events.MOUSE_LEAVE, function () {
		if (utils.hasClass(html, ClassNames.NAVBAR_VERTICAL_COLLAPSED_HOVER)) {
		html.classList.remove(ClassNames.NAVBAR_VERTICAL_COLLAPSED_HOVER);
		}
	});
	}
};

docReady(handleNavbarVerticalCollapsed);